import { z } from 'zod';
import { itemDependencySchema } from './dependency-dto';
import { estimationDisplaySchema, estimationSchema } from './estimation-dto';
import { schedulingTypeSchema } from './item-schedule-dto';
import { itemStatusDisplaySchema, itemStatusSchema } from './item-status-dto';
import { itemTypeDisplaySchema, itemTypeSchema } from './item-type-dto';
import { teamDisplaySchema, teamSchema } from './team-dto';

export const itemSchema = z.object({
  id: z.number().int().positive(),
  name: z.string().optional(),
  priority: z.string(),
  timeSpent: z.number().int().optional(),
  schedulingType: schedulingTypeSchema.optional(),
  description: z.string().optional(),
  targetStartDate: z.number().int().optional(),
  targetFinishDate: z.number().int().optional(),
  doneDate: z.number().int().optional(),
  dependencies: z.array(itemDependencySchema),
  createdAt: z.number().int().optional(),
  updatedAt: z.number().int().optional(),
  createdBy: z.string(),
  updatedBy: z.string(),
  type: itemTypeSchema,
  status: itemStatusSchema,
  parent: z.number().int().positive().optional(),
  team: teamSchema.optional(),
  estimation: estimationSchema.optional(),
});

export const itemSummarySchema = z.object({
  id: z.number().int().positive(),
  name: z.string().optional(),
  priority: z.string(),
  timeSpent: z.number().int().optional(),
  schedulingType: schedulingTypeSchema.optional(),
  description: z.string().optional(),
  targetStartDate: z.number().int().optional(),
  targetFinishDate: z.number().int().optional(),
  doneDate: z.number().int().optional(),
  dependencies: z.array(itemDependencySchema),
  createdAt: z.number().int().optional(),
  updatedAt: z.number().int().optional(),
  createdBy: z.string(),
  updatedBy: z.string(),
  type: itemTypeDisplaySchema,
  status: itemStatusDisplaySchema,
  parent: z.number().int().positive().optional(),
  team: teamDisplaySchema.optional(),
  estimation: estimationDisplaySchema.optional(),
});

export type ItemDTO = z.infer<typeof itemSchema>;
export type ItemSummaryDTO = z.infer<typeof itemSummarySchema>;
